import React from "react";
import "../assets/styles/AnimatedButton.css";

const AnimatedButton = ({ text }) => {
  const href = "https://meetings-na2.hubspot.com/immutaverse/demo-meeting";

  return (
    <a className="animated-button" href={href} target="_blank" rel="noopener noreferrer">
      <div className="button-wrapper">
        <div className="button-text-holder">
          <div className="button-text-wrap">
            <div className="button-text" data-text={text}>
              {text}
            </div>
          </div>
        </div>
        <div className="button-icon-holder">
          <div className="button-icon-text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="button-icon"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="button-icon hover"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </a>
  );
};

export default AnimatedButton;
